export default (storeState, {payload}) => {
  let newState = Object.assign({}, storeState);
  newState.menuCategories = payload;

  return newState;
};
